import { useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle, Loader2, CalendarX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function CancelBookingPage() {
  const { token } = useParams();
  const [state, setState] = useState("confirm"); // confirm | loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  const handleCancel = async () => {
    setState("loading");
    try {
      await axios.post(`/api/public/cancel/${token}`);
      setState("success");
    } catch (err) {
      const detail = err.response?.data?.detail || "Something went wrong. Please try again.";
      setErrorMsg(detail);
      setState("error");
    }
  };

  return (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center p-4">
      <Card className="bg-slate-900/50 border-slate-800 max-w-md w-full">
        <CardContent className="p-8 text-center space-y-6">
          {state === "confirm" && (
            <>
              <div className="flex justify-center">
                <CalendarX className="text-red-400" size={48} />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white mb-2">Cancel Your Booking?</h1>
                <p className="text-slate-400 text-sm">
                  Are you sure you want to cancel this booking request? This action cannot be undone.
                </p>
              </div>
              <Button
                onClick={handleCancel}
                className="bg-red-600 hover:bg-red-700 text-white w-full"
              >
                Yes, Cancel My Booking
              </Button>
            </>
          )}

          {state === "loading" && (
            <div className="flex flex-col items-center gap-4">
              <Loader2 className="animate-spin text-indigo-400" size={40} />
              <p className="text-slate-400">Cancelling your booking...</p>
            </div>
          )}

          {state === "success" && (
            <>
              <div className="flex justify-center">
                <CheckCircle className="text-green-400" size={48} />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white mb-2">Booking Cancelled</h1>
                <p className="text-slate-400 text-sm">
                  Your booking has been successfully cancelled. We hope to see you again soon.
                </p>
              </div>
            </>
          )}

          {state === "error" && (
            <>
              <div className="flex justify-center">
                <XCircle className="text-red-400" size={48} />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white mb-2">Unable to Cancel</h1>
                <p className="text-slate-400 text-sm">{errorMsg}</p>
              </div>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
